export default {
    title: 'Congratulations! Your 360 Evaluation has been launched!',
    goToDashboard: 'Go to dashboard',
};
